import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { firstValueFrom } from 'rxjs';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { ParcsDataService } from 'src/app/core/services/data/parcs-data.service';
import { MessageDialogService } from 'src/app/core/services/helper/message-dialog.service';
import { IFlashResetEntireLotResult } from 'src/app/shared/code/interfaces/parcs-interfaces';
import { ProcessingBannerComponent } from 'src/app/shared/ui/processing-banner/processing-banner.component';


@Component({
  selector: 'app-parcs-flash-utilities',
  standalone: true,
  imports: [
    ProcessingBannerComponent,
    MatCardModule,
    MatTabsModule
  ],
  templateUrl: './parcs-flash-utilities.component.html',
  styleUrl: './parcs-flash-utilities.component.scss'
})
export class ParcsFlashUtilitiesComponent {
  isProcessing: boolean = false;
  processingMessage: string = 'Processing...';

  _parcsDataService = inject(ParcsDataService);
  _appGeneralState = inject(AppGeneralStateService);
  _messageService = inject(MessageDialogService);

  // "Reset All Active Parkers" button - resets every active Parker's Flash account to neutral
  // for the current lot. Backed by ParcsController.Flash_ResetEntireLot, which can take several
  // minutes to an hour to complete for a large lot.
  async onResetAllActiveParkers(): Promise<void> {
    this.isProcessing = true;
    this.processingMessage =
      'Setting all active Parker accounts to neutral.  This may take several minutes to an hour';

    try {
      const result: IFlashResetEntireLotResult = await firstValueFrom(
        this._parcsDataService.flash_ResetEntireLot(this._appGeneralState.currentLotNumber),
      );

      this.isProcessing = false;

      this._messageService.snackBarTopCenterStatic(
        `Reset Complete - ${result.successCount} of ${result.totalParkersFound} Parker(s) reset successfully` +
          (result.failureCount > 0 ? `, ${result.failureCount} failed` : ''),
      );
    } catch (err) {
      this.isProcessing = false;
      this._messageService.snackBarErrorTopCenterStatic('Error occurred while resetting the lot. Please try again.');
    }
  }
}
